const getAndListPropertyDocuments = async ({ propertyId, buildingId, fileInputId, fileInputLabel, documentRow }) => {
  try {
    const propertyDocumentsData = await getImpowerXData(`${baseApiUrl}/api/impowerX/documents?propertyId=${propertyId}&buildingId=${buildingId}&fileInputId=${encodeURIComponent(fileInputId)}&fileInputLabel=${encodeURIComponent(fileInputLabel)}`)
    const propertyDocuments = propertyDocumentsData?.documents
    if (!propertyDocuments || propertyDocuments.length === 0) return
    ListPropertyDocuments(propertyDocuments, documentRow)
  } catch (e) {
    console.error('[ImpowerX] Failed to get and list documents', e)
  }
}

const handleImpowerxFileInputChange = async function ({ files, propertyId, buildingId, fileInputId, fileInputLabel, documentRow }) {

  const filesArray = Array.from(files)
  if (!filesArray || filesArray.length === 0) return

  try {
    addLoadingOverlay(documentRow);

    const tagsSource = (typeof window !== 'undefined' && window.propertyDocumentTags) || []
    let documentTagInfo = Array.isArray(tagsSource) ? tagsSource.find(tag => fileInputId.includes(tag.documentLabelEN.toLowerCase()) || fileInputLabel.includes(tag.documentLabelDE.toLowerCase()) || (tag.additionalDocumentLabel && fileInputId.includes(tag.additionalDocumentLabel.toLowerCase()))) : undefined
    const tagCode = documentTagInfo?.tagCode
    if (!tagCode) {
      console.error('[ImpowerX] Tag code not found for fileInputId:', fileInputId)
      return
    }
    const codesSource = (typeof window !== 'undefined' && window.allowedPropertyDocumentTagCodes) || []
    const isValidTagCode = Array.isArray(codesSource) ? codesSource.includes(tagCode) : false
    if (!isValidTagCode) {
      console.error('[ImpowerX] Invalid tag code:', tagCode)
      return
    }

    let additionalTagIds = []
    if (documentTagInfo?.additionalTagName) {
      try {
        const additionalTagsUrl = new URL(`${baseApiUrl}/services/pmp-public/v2/document-tags`)
        additionalTagsUrl.searchParams.append('description', documentTagInfo.additionalTagName)
        const additionalTagsResponse = await fetch(additionalTagsUrl.toString(), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        if (additionalTagsResponse.ok) {
          const additionalTags = await additionalTagsResponse.json()
          if (additionalTags && Array.isArray(additionalTags) && additionalTags.length > 0) {
            additionalTagIds = additionalTags.map(tag => tag.id)
          }
        }  
        
        if (additionalTagIds.length === 0) {
          const createdTagResponse = await fetch(`${baseApiUrl}/services/pmp-public/v2/document-tags`, 
            {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
              body: JSON.stringify({
                name: documentTagInfo.additionalTagName,
                description: documentTagInfo.documentLabelDE,
              }),
            }
          )
          if (!createdTagResponse.ok) {
            console.error('[ImpowerX] Failed to create additional tag', createdTagResponse.status)
            return
          }
          const createdTag = await createdTagResponse.json()
          if(createdTag && createdTag.id) {
            additionalTagIds.push(createdTag.id)
          }
        }
      } catch (error) {
        console.error('[ImpowerX] Failed to fetch or create tag', error)
      }
    }

    let allDocuments = []

    let documentsToProcess = []
    for (const file of filesArray) {
      const formData = new FormData()
      formData.append('file', file, file.name)
      const uploadUrl = new URL(`${baseApiUrl}/services/pmp-document/api/v1/documents/upload`)

      const safeName = encodeURIComponent(file.name.replace(/[\\/&?:]/g, '_'))
      const uploadQueryParams = `?name=${safeName}&propertyId=${propertyId}
                            &tagCode=${tagCode}
                            &sourceType=${documentTagInfo?.sourceType ?? 'OTHER'}
                            &ocrState=${documentTagInfo?.ocrState ?? 'NO_OCR'}
                            `
      const documentToUpload = fetch(uploadUrl.toString() + uploadQueryParams, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        body: formData,
      })
      documentsToProcess.push(documentToUpload)
    }
    const allDocumentsResults = await Promise.allSettled(documentsToProcess)
    for (const result of allDocumentsResults) {
      if (result.status === 'fulfilled') {
        const response = result.value
        if (!response.ok) {
          const errorText = await response.text().catch(() => 'Unknown error')
          console.error('[ImpowerX] Failed to upload document', response.status, errorText)
          continue
        }
        allDocuments.push(await response.json())
      } else {
        console.error('[ImpowerX] Failed to upload document', result.reason)
      }
    }

    if (allDocuments.length > 0 && (buildingId || additionalTagIds.length > 0)) {
      const updateDocuments = allDocuments.map(document => {
        const existingTagIds = document.tags?.map(t => t.id) || []
        const tagIds = additionalTagIds.length > 0
          ? Array.from(new Set(existingTagIds.concat(additionalTagIds)))
          : existingTagIds
        return {
          id: document.id,
          name: document.name,
          propertyId: propertyId,
          buildingId: buildingId ?? undefined,
          tagIds,
        }
      })
      const updateDocumentsResponse = await fetch(`${baseApiUrl}/services/pmp-document/api/v1/documents`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(
          updateDocuments),
      })
      if (!updateDocumentsResponse.ok) {
        console.error('[ImpowerX] Failed to update documents', updateDocumentsResponse.status)
        return
      }
      const updatedDocuments = await updateDocumentsResponse.json()
      allDocuments = updatedDocuments
    }
    if (!allDocuments || allDocuments.length === 0) return
    ListPropertyDocuments(allDocuments, documentRow, false)

  } catch (e) {
    console.error('[ImpowerX] Failed to upload documents', e)
  } finally {
    removeLoadingOverlay(documentRow)
  }
}

const downloadFileByUrl = (url, filename) => {
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const ListPropertyDocuments = async (propertyDocuments, documentRow) => {
  try {
    if (!propertyDocuments || propertyDocuments.length === 0) return

    const isInEditMode = localStorage.getItem('isInEditMode') === 'true';
    let documentContainer = documentRow.querySelector('.impower-x-documents-container')
    if (!documentContainer) {
      documentContainer = document.createElement('div')
      documentContainer.classList.add('impower-x-documents-container')
      documentContainer.style.maxHeight = '240px'
      documentContainer.style.overflowY = 'auto'
      documentContainer.style.padding = '1.5rem'
      documentRow.appendChild(documentContainer)
    }

    if (propertyDocuments.length) {
      propertyDocuments.forEach(propertyDocument => {
        const { name, id: documentId } = propertyDocument
        const documentElement = document.createElement('div')
        documentElement.classList.add('line', 'second-row')
        documentElement.style = 'display: flex; align-items: center; justify-content: space-between; gap: 8px;'
        documentElement.innerHTML = `
          <div style="flex: 1;">
            <span role="img" class="anticon">
              <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4V1L9 4H6ZM1.25 0C0.5625 0 0.00625 0.585 0.00625 1.3L0 11.7C0 12.415 0.55625 13 1.24375 13H8.75C9.4375 13 10 12.415 10 11.7V3.9L6.25 0H1.25Z" fill="#7F7F7F"></path></svg>
            </span>
            <div class="file-name">
              <a class="download-document" style="text-decoration: none;">${name.length > 50 ? name.substring(0, 50) + '...' : name}</a>
            </div>
          </div>
          <button style="cursor: pointer; position: relative;" class="delete-button" data-document-id="${documentId}" ${!isInEditMode ? 'disabled' : ''}>
            <span role="img" class="anticon">
            <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.26 21H14.74L16 7H2L3.26 21ZM13 4V2C13 1.46957 12.7893 0.960859 12.4142 0.585786C12.0391 0.210714 11.5304 0 11 0H7C6.46957 0 5.96086 0.210714 5.58579 0.585786C5.21071 0.960859 5 1.46957 5 2V4H0V6H18V4H13ZM11 4H7V2H11V4Z" fill="black"></path></svg>
            </span>
          </button> 
      `

        const downloadDocument = documentElement.querySelector('.download-document')
        if (downloadDocument) {
          downloadDocument.addEventListener('click', async (e) => {
            e.preventDefault()
            e.stopPropagation()
            try {
              const token = JSON.parse(localStorage.getItem('auth'))?.token
              const resp = await fetch(`${baseApiUrl}/api/impowerX/documents/${encodeURIComponent(documentId)}/download`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              })
              if (!resp.ok) {
                console.error('[ImpowerX] Failed to download document', resp.status)
                alert('Failed to download document')
                return
              }
              const blob = await resp.blob()
              const objectUrl = URL.createObjectURL(blob)
              downloadFileByUrl(objectUrl, name)
              URL.revokeObjectURL(objectUrl)
            } catch (err) {
              console.error('[ImpowerX] Error downloading document', err)
              alert('Failed to download document')
            }
          })
        }

        const deleteBtn = documentElement.querySelector('.delete-button')
        if (deleteBtn) {
          deleteBtn.addEventListener('click', async (e) => {
            if (deleteBtn.disabled || deleteBtn.hasAttribute('disabled')) {
              e.preventDefault()
              e.stopPropagation()
              return
            }
            
            try {
              const resp = await deleteImpowerXData(`${baseApiUrl}/api/impowerX/documents/${encodeURIComponent(documentId)}`)
              if (!resp.ok) {
                console.error('[ImpowerX] Failed to delete document', resp.status)
                alert('Failed to delete document')
                return
              }
              documentElement.remove()
            } catch (err) {
              console.error('[ImpowerX] Error deleting document', err)
              alert('Failed to delete document')
            }
          })
        }
        documentContainer.appendChild(
          documentElement
        )
      })
    }
  } catch (e) {
    console.error('[ImpowerX] Failed to list documents', e)
  }
}

// Helper function to format file size
const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

// Helper function to show error message near file input
const showFileInputError = (fileInput, message) => {
  const existingError = fileInput.parentElement?.querySelector('.impowerx-file-error');
  if (existingError) {
    existingError.remove();
  }

  const errorMsg = document.createElement('div');
  errorMsg.className = 'impowerx-file-error';
  errorMsg.style.cssText = `
    background: #fef2f2;
    color: #dc2626;
    padding: 0.5rem 0.75rem;
    border-radius: 0.25rem;
    margin-top: 0.5rem;
    font-size: 1.6rem;
    border-left: 0.2rem solid #dc2626;
    max-width: 100%;
  `;
  errorMsg.textContent = message;

  const insertAfter = fileInput.parentElement || fileInput;
  insertAfter.appendChild(errorMsg);

  setTimeout(() => {
    if (errorMsg.parentElement) {
      errorMsg.remove();
    }
  }, 5000);
};

const addLoadingOverlay = (parentEl) => {
  if (!parentEl) return;
  if (parentEl.querySelector('.impowerx-loading-overlay')) return;
  const currentPosition = window.getComputedStyle(parentEl).position;
  if (currentPosition === 'static') {
    parentEl.dataset.impowerxLoadingMadeRelative = 'true';
    parentEl.style.position = 'relative';
  }
  const overlay = document.createElement('div');
  overlay.className = 'impowerx-loading-overlay';
  overlay.style.cssText = 'position:absolute;inset:0;background:rgba(255,255,255,0.6);display:flex;align-items:center;justify-content:center;z-index:10;';
  overlay.innerHTML = `
    <div class="ant-spin ant-spin-spinning">
      <span class="ant-spin-dot ant-spin-dot-spin" style="color: black;">
        <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.3;"></i>
        <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.5;"></i>
        <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.7;"></i>
        <i class="ant-spin-dot-item" style="background-color: black; opacity: 0.9;"></i>
      </span>
    </div>
  `;
  parentEl.appendChild(overlay);
};

const removeLoadingOverlay = (parentEl) => {
  if (!parentEl) return;
  const overlay = parentEl.querySelector('.impowerx-loading-overlay');
  if (overlay) overlay.remove();
  if (parentEl.dataset.impowerxLoadingMadeRelative === 'true') {
    parentEl.style.removeProperty('position');
    delete parentEl.dataset.impowerxLoadingMadeRelative;
  }
};